import './App.css';
import { router } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React, { useEffect } from 'react';

function App() {
  useEffect(() => {
    const handleScrollTop = () => {
      window.scrollTo({ top: 0, behavior: 'auto' });
    };

    // Usamos window.history para evitar el warning de ESLint
    const pushState = window.history.pushState;
    const replaceState = window.history.replaceState;

    window.history.pushState = function (...args) {
      pushState.apply(window.history, args);
      handleScrollTop();
    };

    window.history.replaceState = function (...args) {
      replaceState.apply(window.history, args);
      handleScrollTop();
    };

    window.addEventListener('popstate', handleScrollTop);

    // Scroll arriba al cargar
    handleScrollTop();

    return () => {
      window.history.pushState = pushState;
      window.history.replaceState = replaceState;
      window.removeEventListener('popstate', handleScrollTop);
    };
  }, []);

  return <RouterProvider router={router} />;
}

export default App;
// VenderAuto.jsx